import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { RetailerService } from '../../retailer.service';
import { HttpParams } from '@angular/common/http';
import { CurrencyPipe, formatDate } from '@angular/common';
import * as moment from 'moment';
import { ActivatedRoute } from '@angular/router';
import { Params, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from 'src/app/features-common/components/dialog/dialog.component';
import { JwtHelperService } from "@auth0/angular-jwt";
import { CustomTooltip } from 'src/app/features-common/components/tool-tip/tool-tip.component';
import { ViewCommentComponent } from './view-comment.component';
const helper = new JwtHelperService();

@Component({
  selector: 'app-comments',
  templateUrl: './comments.component.html',
  styleUrls: ['./comments.component.scss'],
  providers: [CurrencyPipe]
})
export class CommentsComponent extends FeaturesBaseComponent implements OnInit {
  frameworkComponents;
  searchValue: any;
  gridApi: any;
  isLogSelected: boolean = false;
  gridColumnApi: any;
  selectedRows: any;
  showEditPromotion: boolean;
  isUserLogsActive: boolean = true;
  isSystemLogsActive: boolean = false;
  rowData: any;
  columnDefs: any;
  defaultColDef: any;
  minFromDate: Date;
  maxDate: Date = new Date();
  minToDate: Date;
  transactionFromDate: string;
  transactionToDate: string;
  retailerId: any;
  commentId: any;
  userRole: string;
  storeName: string;
  retailerName: string;
  accountNumber: any;
  tooltipShowDelay: number;
  showCard: boolean = true;


  constructor(public dialog: MatDialog, private router: Router, private retailerService: RetailerService, private currencyPipe: CurrencyPipe, private activeRoute: ActivatedRoute) {
    super();
    const self = this;
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this.retailerId = this.activeRoute.snapshot.params.retailerId;
    this.retailerService.getSelectedRetailer(this.retailerId).subscribe(res => {
      if (res['httpcode'] == 200) {
        ;
        this.storeName = res.data.retailerDetails.dbaName;
        this.retailerName = res.data?.retailerDetails?.businessName;
        this.accountNumber = res.data?.retailerAccounts?.retailerAccountNum;
      }
    })
    var dt = new Date();
    dt.setDate(dt.getDate() - 30);
    this.transactionToDate = moment(new Date()).format('YYYY-MM-DD');
    this.transactionFromDate = moment(dt).format('YYYY-MM-DD');


    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      tooltipComponent: 'customTooltip',
    };
    this.tooltipShowDelay = 0;
    this.frameworkComponents = { customTooltip: CustomTooltip };

    this.columnDefs = [
      { field: 'commentId', headerName: 'commentId', width: 190, hide: true, sort: "desc" },
      { field: 'null', headerName: 'Action', width: 150, checkboxSelection: true },
      {
        field: 'comment', headerName: 'Comment', width: 190, tooltipField: 'comment',
        tooltipComponentParams: { color: '#ececec' }, cellRenderer: (data) => {
          return `<span class="mb-0">${data.value} </span>`;
        },
        onCellClicked: function (params) {
          self.handleViewMessage(params.data);
        },
      },
      {
        field: 'visitedDate', headerName: 'Visited Date', width: 180, cellRenderer: (data) => {
          return formatDate(data.value, 'MM/dd/yyyy', 'en')
        }
      },
      { field: 'visitedTime', headerName: 'Visited Time', width: 180, },
      { field: 'visitType', headerName: 'Visit Type', width: 190, },
      { field: 'spokeWith', headerName: 'Spoke With', width: 190, },
      { field: 'retailerName', headerName: 'Retailer Name', width: 190, },
      { field: 'dbaName', headerName: 'DBA Name', width: 190, },
      { field: 'accountNumber', headerName: 'Account Number', width: 230, },
      {
        field: 'updatedDttm', headerName: 'Updated Date', width: 180, cellRenderer: (data) => {
          return formatDate(data.value, 'MM/dd/yyyy', 'en')
        }
      },
    ]
    if (this.userRole == "Super Admin" || this.userRole == "Sub Admin" || this.userRole == "Billing Dept" || this.userRole == "Customer Service") {
      this.columnDefs.splice(12, 0, { field: 'updatedBy', headerName: 'Updated By', width: 190 },
      )
    }

  }
  handleViewMessage(message) {
    // Open a mat dilog to compose message
    const dialogRef = this.dialog.open(ViewCommentComponent, {
      panelClass: "view-message",
      minHeight: "200px",
      maxHeight: "400px",
      width: "50vw",
      data: message.comment,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.gridApi.refreshCells();
    });
  }


  loadData() {
    let params: any = new HttpParams().set('retailerId', this.retailerId).set('startDate', this.transactionFromDate).set('endDate', this.transactionToDate)
    this.retailerService.getComments(params).subscribe(res => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.setGrid(resData);
      }
    })
  }
  setGrid(resData) {
    const self = this; self
    this.rowData = resData;

  }
  exportData() {
    let header = this.columnDefs.map(columnDef => {
      switch (columnDef.headerName) {
        case 'Visited Date': {
          return 'Date';
        }
        case 'Visited Time': {
          return 'Time';
        }
        case 'Visited Time': {
          return 'Time';
        }
        default: {
          return columnDef.headerName;
        }
      };
    });

    let params: any = {
      fileName: 'Comments-History.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if (cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      } else if (cellParams && cellParams.column.colId === 'visitedDate' || cellParams.column.colId === 'updatedDttm') {
        return moment(cellParams.value).format('MM/DD/YYYY')
      } else if (this.userRole == "Super Admin" || this.userRole == "Sub Admin" || this.userRole == "Billing Dept" || this.userRole == "Customer Service") {
        return cellParams.value
      }
      else {
        console.log(cellParams.value);

        return cellParams.value // no formatting
      }
    }
    this.gridApi.exportDataAsCsv(params);
  }
  handleExport(data: any) {
    let invoiceId = data;

  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  onSelectUserLogs() {
    this.isUserLogsActive = true;
    this.isSystemLogsActive = !this.isUserLogsActive
  }
  onSelectSystemLogs() {
    this.isSystemLogsActive = true;
    this.isUserLogsActive = !this.isSystemLogsActive;
  }

  deleteLog() {

  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //setTimeout(() => { params.api.sizeColumnsToFit() }, 50);
    this.loadData()
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != [] && this.selectedRows.length! > 0) {
      this.commentId = this.selectedRows[0].commentId;
      this.isLogSelected = true;
      return
    }
    this.isLogSelected = false;

  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.transactionFromDate = moment(e.value).format('YYYY-MM-DD');
    if (this.transactionToDate != null && this.transactionToDate != undefined) {
      let params: any = new HttpParams().set('retailerId', this.retailerId).set('startDate', this.transactionFromDate).set('endDate', this.transactionToDate)
      this.retailerService.getComments(params).subscribe(res => {
        let resData: any = res;
        if (resData.httpcode == 200) {
          resData = resData.data;
          this.setGrid(resData);
        }
      })
    }
  }

  changeToDate(e) {
    this.transactionToDate = moment(e.value).format('YYYY-MM-DD');
    if (this.transactionFromDate != null && this.transactionFromDate != undefined) {
      let params: any = new HttpParams().set('retailerId', this.retailerId).set('startDate', this.transactionFromDate).set('endDate', this.transactionToDate)
      this.retailerService.getComments(params).subscribe(res => {
        let resData: any = res;
        if (resData.httpcode == 200) {
          resData = resData.data;
          this.setGrid(resData);
        }
      })
    }
  }
  createData() {
    this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}/create/${this.retailerId}`])
  }
  editData() {
    let _commentId = this.selectedRows[0].commentId;
    this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}/edit/${_commentId}`])
  }
  deleteData() {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        message: 'Are You Sure Want To Delete',
        buttonText: {
          ok: 'Delete',
          cancel: 'pages.placeholders.cancel'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        let _commentId = this.selectedRows[0].commentId;
        this.retailerService.deleteComment(_commentId).subscribe(res => {
          let resData: any = res;
          this.loadData();
          if (resData.httpcode == 200) {
            this.toastrService.success('Deleted Comment successfully', 'Success', {
              timeOut: 3000,
            });
          }
        })
      } else {
        this.router.navigate([`features/retailers/manageretailer/${this.retailerId}/comments/${this.retailerId}`])
      }
    });
  }
}
